export default __webpack_public_path__ + "07b9a2b9d751e5774c0bda09f76a11f3.svg";